import { configureStore } from '@reduxjs/toolkit';
import authReducer from './reducer/auth.reducer';
import itemReducer from './reducer/item.reducer';
import documentReducer from './reducer/document.reducer';
import dropdownReducer from './reducer/dropdown.reducer';
import priceReducer from './reducer/price.reducer';
import distributorReducer from './reducer/distributor.reducer';
import shipmentReducer from './reducer/shipment.reducer';
import summaryReducer from './reducer/summary.reducer';

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

const store = configureStore({
    reducer: {
        auth: authReducer,
        document: documentReducer,
        summary: summaryReducer,
        dropdown: dropdownReducer,
        msItem:itemReducer,
        msPrice:priceReducer,
        msDistributor:distributorReducer,
        msShipment:shipmentReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default store;
